import React, { Children } from 'react';
import { motion } from 'framer-motion';
const failedMethods = [{
  title: 'Abdominales tradicionales',
  desc: 'Aumentan la presión interna y empeoran la incontinencia.',
  icon: <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-13">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" data-id="element-14" />
      </svg>
}, {
  title: 'Cardio de alto impacto',
  desc: 'Daña los ligamentos que sostienen tu útero y vejiga.',
  icon: <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-15">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-16" />
      </svg>
}, {
  title: 'Fajas',
  desc: 'Solo "esconden" el problema, debilitando aún más tus músculos por falta de uso.',
  icon: <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-17">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" data-id="element-18" />
      </svg>
}, {
  title: 'Ejercicios de Kegel mal ejecutados',
  desc: 'Tensan el músculo pero no restauran la función del abdomen.',
  icon: <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-19">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-20" />
      </svg>
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function FailedSection() {
  return <section className="py-12 md:py-24 bg-white" data-id="element-21">
      <div className="max-w-6xl mx-auto px-5 lg:px-8" data-id="element-22">
        <div className="text-center mb-8 md:mb-16" data-id="element-23">
          <h2 className="text-2xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-24">
            Por qué lo que has intentado no funciona
          </h2>
          <div className="w-24 h-px bg-rosegold mx-auto" data-id="element-25"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-30px'
      }} className="grid md:grid-cols-2 gap-4 md:gap-8 lg:gap-12" data-id="element-26">
          {failedMethods.map((method, index) => <motion.div key={index} variants={itemVariants} className="flex items-start space-x-4 md:space-x-6 p-4 md:p-6 rounded-lg border border-rosegold/10" data-id="element-27">
              <div className="flex-shrink-0 text-rosegold" data-id="element-28">{method.icon}</div>
              <div data-id="element-29">
                <h3 className="text-lg md:text-xl font-serif text-charcoal mb-1 md:mb-2" data-id="element-30">
                  {method.title}
                </h3>
                <p className="text-charcoal/70 leading-relaxed text-sm md:text-base" data-id="element-31">
                  {method.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}